<template>
    <div :class="{ containerClasses }">
      <label
        class="block font-minion text-[18px] font-bold text-primary-400"
        :class="labelClasses"
        :for="labelFor"
        >{{ inputLabel }}</label
      >
      <input
        v-if="!isPassword"
        class="outline-primary-400 rounded border border-primary-400 w-full py-3 px-4 placeholder:text-placeholder lg:px-6 lg:py-4 text-primary-400 font-minion text-[18px] md:mt-2"
        :class="inputClasses"
        :type="inputType"
        :name="inputName"
        :id="inputId"
        :placeholder="inputPlaceholder"
        :value="modelValue"
        :disabled="disabled"
        :inputmode="inputmode"
        :maxlength="maxlength"
        @input="updateValue"
      />
      <div class="relative" v-if="isPassword">
        <input
          class="outline-primary-400 rounded border border-primary-400 w-full py-3 px-4 pr-9 placeholder:text-placeholder lg:px-6 lg:py-4 lg:pr-10 text-primary-400 font-minion text-[18px] md:mt-2"
          :class="inputClasses"
          :type="isPasswordHidden ? 'password' : 'text'"
          :name="inputName"
          :id="inputId"
          :placeholder="inputPlaceholder"
          :value="modelValue"
          @input="updateValue"
        />
        <button
          type="button"
          class="absolute top-1/2 right-3 -translate-y-1/2 h-6 w-6 md:-translate-y-2"
          @click="toggleIsPasswordHidden"
        >
          <svg
            class="h-6 w-6"
            v-show="!isPasswordHidden"
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <mask
              id="mask0_1327_29396"
              style="mask-type: alpha"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="48"
              height="48"
            >
              <rect width="48" height="48" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_1327_29396)">
              <path
                d="M31.45 27.05L29.25 24.85C30.1167 22.4833 29.6667 20.5167 27.9 18.95C26.1333 17.3833 24.2167 16.9833 22.15 17.75L19.95 15.55C20.5167 15.1833 21.15 14.9167 21.85 14.75C22.55 14.5833 23.2667 14.5 24 14.5C26.3667 14.5 28.375 15.325 30.025 16.975C31.675 18.625 32.5 20.6333 32.5 23C32.5 23.7333 32.4083 24.4583 32.225 25.175C32.0417 25.8917 31.7833 26.5167 31.45 27.05ZM37.9 33.5L35.9 31.5C37.5333 30.3 38.9583 28.9583 40.175 27.475C41.3917 25.9917 42.2833 24.5 42.85 23C41.1833 19.3 38.6833 16.375 35.35 14.225C32.0167 12.075 28.4 11 24.5 11C23.1 11 21.6667 11.1333 20.2 11.4C18.7333 11.6667 17.5833 11.9833 16.75 12.35L14.45 10C15.6167 9.46667 17.1083 9 18.925 8.6C20.7417 8.2 22.5167 8 24.25 8C29.0167 8 33.375 9.35833 37.325 12.075C41.275 14.7917 44.1667 18.4333 46 23C45.1333 25.1333 44.0167 27.0833 42.65 28.85C41.2833 30.6167 39.7 32.1667 37.9 33.5ZM40.8 44.8L32.4 36.55C31.2333 37.0167 29.9167 37.375 28.45 37.625C26.9833 37.875 25.5 38 24 38C19.1333 38 14.7167 36.6417 10.75 33.925C6.78333 31.2083 3.86667 27.5667 2 23C2.66667 21.2667 3.59167 19.575 4.775 17.925C5.95833 16.275 7.4 14.7 9.1 13.2L2.8 6.9L4.9 4.75L42.75 42.6L40.8 44.8ZM11.15 15.3C9.91667 16.2 8.725 17.3833 7.575 18.85C6.425 20.3167 5.6 21.7 5.1 23C6.8 26.7 9.35833 29.625 12.775 31.775C16.1917 33.925 20.0667 35 24.4 35C25.5 35 26.5833 34.9333 27.65 34.8C28.7167 34.6667 29.5167 34.4667 30.05 34.2L26.85 31C26.4833 31.1667 26.0333 31.2917 25.5 31.375C24.9667 31.4583 24.4667 31.5 24 31.5C21.6667 31.5 19.6667 30.6833 18 29.05C16.3333 27.4167 15.5 25.4 15.5 23C15.5 22.5 15.5417 22 15.625 21.5C15.7083 21 15.8333 20.55 16 20.15L11.15 15.3Z"
                fill="#9A9AB0"
              />
            </g>
          </svg>
          <svg
            class="h-6 w-6"
            v-show="isPasswordHidden"
            width="49"
            height="49"
            viewBox="0 0 49 49"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <mask
              id="mask0_1327_29426"
              style="mask-type: alpha"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="49"
              height="49"
            >
              <rect
                x="0.362305"
                y="0.885254"
                width="48"
                height="48"
                fill="#D9D9D9"
              />
            </mask>
            <g mask="url(#mask0_1327_29426)">
              <path
                d="M24.3623 32.3853C26.729 32.3853 28.7373 31.5603 30.3873 29.9103C32.0373 28.2603 32.8623 26.2519 32.8623 23.8853C32.8623 21.5186 32.0373 19.5103 30.3873 17.8603C28.7373 16.2103 26.729 15.3853 24.3623 15.3853C21.9956 15.3853 19.9873 16.2103 18.3373 17.8603C16.6873 19.5103 15.8623 21.5186 15.8623 23.8853C15.8623 26.2519 16.6873 28.2603 18.3373 29.9103C19.9873 31.5603 21.9956 32.3853 24.3623 32.3853ZM24.3623 29.4853C22.7956 29.4853 21.4706 28.9436 20.3873 27.8603C19.304 26.7769 18.7623 25.4519 18.7623 23.8853C18.7623 22.3186 19.304 20.9936 20.3873 19.9103C21.4706 18.8269 22.7956 18.2853 24.3623 18.2853C25.929 18.2853 27.254 18.8269 28.3373 19.9103C29.4206 20.9936 29.9623 22.3186 29.9623 23.8853C29.9623 25.4519 29.4206 26.7769 28.3373 27.8603C27.254 28.9436 25.929 29.4853 24.3623 29.4853ZM24.3623 38.8853C19.4956 38.8853 15.0956 37.5019 11.1623 34.7353C7.22897 31.9686 4.29564 28.3519 2.3623 23.8853C4.29564 19.4186 7.22897 15.8019 11.1623 13.0353C15.0956 10.2686 19.4956 8.88525 24.3623 8.88525C29.229 8.88525 33.629 10.2686 37.5623 13.0353C41.4956 15.8019 44.429 19.4186 46.3623 23.8853C44.429 28.3519 41.4956 31.9686 37.5623 34.7353C33.629 37.5019 29.229 38.8853 24.3623 38.8853ZM24.3623 35.8853C28.3956 35.8853 32.104 34.7936 35.4873 32.6103C38.8706 30.4269 41.4456 27.5186 43.2123 23.8853C41.4456 20.2519 38.8706 17.3436 35.4873 15.1603C32.104 12.9769 28.3956 11.8853 24.3623 11.8853C20.329 11.8853 16.6206 12.9769 13.2373 15.1603C9.85397 17.3436 7.2623 20.2519 5.4623 23.8853C7.2623 27.5186 9.85397 30.4269 13.2373 32.6103C16.6206 34.7936 20.329 35.8853 24.3623 35.8853Z"
                fill="#9A9AB0"
              />
            </g>
          </svg>
        </button>
      </div>
    </div>
  </template>
  <script setup>
  import { ref } from "vue";
  
  const isPasswordHidden = ref(true);
  
  function toggleIsPasswordHidden(e) {
    isPasswordHidden.value = !isPasswordHidden.value;
  }
  
  const props = defineProps({
    inputLabel: {
      type: String,
      default: "Label",
    },
    labelFor: {
      type: String,
      default: "myInput",
    },
    inputType: {
      type: String,
      default: "text",
    },
    inputName: {
      type: String,
      default: "",
    },
    inputId: {
      type: String,
      default: "myInput",
    },
    inputPlaceholder: {
      type: String,
      default: "Placeholder",
    },
    modelValue: {
      type: String,
      default: "",
    },
    isPassword: {
      type: Boolean,
      default: false,
    },
    containerClasses: {
      type: String,
      default: "",
    },
    labelClasses: {
      type: String,
      default: "",
    },
    inputClasses: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    maxlength: {
      type: Number,
    },
    inputmode:{
      type: String,
      default: "",
    }
  });
  
  const emit = defineEmits(["update:modelValue", "formInputChange"]);
  
  const updateValue = (event) => {
    emit("update:modelValue", event.target.value);
    emit("formInputChange", event);
  };
  </script>
  